module.exports = __webpack_public_path__ + "img/magento-support-security.4a54bdd4.webp";